<template>
    <v-container max-width="100%" style="margin-top: 2%">

    <v-card style="margin-bottom: 10px;">
      <v-card-title>
        <h2 class="headline" style="color: #4a4a4a">{{ $tc('relPlot.self', 1) }}</h2>
      </v-card-title>
    </v-card>

    <v-container class="toolbar__container">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="4" md="3">
            <LazySelect
              ref="empresaSelect"
              get-url="getEmpresaslazy"
              text="razao_social"
              value="id_empresa"
              :label="$tc('company.self', 1)"
              @input="onEmpresaInput"
            />
          </v-col>
          <!-- adicionar unidade -->
          <v-col cols="12" sm="6" md="3">
            <MultiplaEscolha
              ref="unidadesSelect"
              lazy
              get-url="getUnidadeslazy"
              :items="semUnidadeOption"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <!-- termina unidade -->
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timeProps"
              :date-picker-props="dtiProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timeProps"
              :date-picker-props="dtfProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <MultiplaEscolha
              ref="veiculosSelect"
              lazy
              get-url="getVeiculoslazy"
              :request-data="lazySelectRequestData"
              v-bind:selected-items.sync="idVeiculosSelected"
              text="numero_ordem"
              value="id_veiculo"
              :label="$tc('vehicle.self', 1)"
              :max-items="3"
              :rules="[(v) => (!!v && v.length > 0 && v.length <= 3) || $t('vehicle.rules.selectBetween1and3')]"
            />
          </v-col>
          <v-col cols="12" sm="6" md="1">
            <div style="display: flex; justify-content: flex-end; gap: 10px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                    @click="populaRelatorio">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('operation.search') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                    @click="setDefaultFilters">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('operation.newConsult') }}</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-dialog v-model="showMapa" fullscreen max-width="100%">
      <v-card>
        <v-toolbar dark color="primary" ref="myToolbar">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('equipStatus.map') }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <MapaPlotagem ref="mapaPlotagem" :idVeiculo="idVeiculosSelected" :dti="dtiMapa" :dtf="dtfMapa"
            :posicoes="posicoes" :user="user" :token="token" :key="key" style="margin-top: 30px;"></MapaPlotagem>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import MapaPlotagem from "./MapaPlotagem.vue";
import DateUtils from "../utils/dateutils";
import EventBus from "@/utils/eventBus";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import LazySelect from './Selects/LazySelect.vue';

export default {
  components: {
    MapaPlotagem,
    MultiplaEscolha,
    LazySelect,
  },
  data: () => ({
    autorizacaoDialog: false,
    mensagemAutorizacaoDialog: "",
    alertForm: false,
    alertFormMessage: "",
    user: null,
    token: null,
    config: null,
    loading: false,
    search: "",
    posicoes: [],
    unidadesSelecionadas: [],
    dti: null,
    dtf: null,
    dtiMapa: null,
    dtfMapa: null,
    showMapa: false,
    idEmpresaSelected: null,
    idVeiculosSelected: [],
    timeProps: {
      useSeconds: true,
    },
    formValidado: false,
    key: 0,
  }),
  computed: {
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')],
      }
    },
    today() {
      return new Date().toISOString().substring(0, 10);
    },
    dtiProps() {
      return {
        max: this.today,
        rules: [this.dtRules]
      }
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
        } else {
          min = this.dti.toISOString().substring(0, 10);
        }
      }
      return {
        min: min,
        rules: [this.dtRules]
      }
    },
    semUnidadeOption() {
      return [
        {
          id_unidade: -1,
          descricao_unidade: 'Sem Unidade',
          cod_unidade: 'SU',
        },
      ];
    },
    lazySelectRequestData() {
      const data = {};
      if (this.idEmpresaSelected != null && this.idEmpresaSelected !== '') {
        const idEmpresa = Number(this.idEmpresaSelected);
        if (Number.isFinite(idEmpresa) && idEmpresa > 0) {
          data.id_empresa = idEmpresa;
        }
      }
      const unidades = (this.unidadesSelecionadas || []).map((id) => Number(id));
      const reais = unidades.filter((id) => Number.isFinite(id) && id > 0);
      const temSemUnidade = unidades.includes(-1);
      if (reais.length === 1 && !temSemUnidade) {
        data.id_unidade = reais[0];
      } else if (temSemUnidade && reais.length === 0) {
        data.id_unidade = -1;
      }
      return data;
    },
    dateDiff() {
      let start = typeof this.dti === "string" ?
        new Date(this.dti.substring(6, 10), this.dti.substring(3, 5) - 1, this.dti.substring(0, 2), this.dti.substring(11, 13), this.dti.substring(14, 16), this.dti.substring(17, 19)) :
        this.dti;
      let end = typeof this.dtf === "string" ?
        new Date(this.dtf.substring(6, 10), this.dtf.substring(3, 5) - 1, this.dtf.substring(0, 2), this.dtf.substring(11, 13), this.dtf.substring(14, 16), this.dtf.substring(17, 19)) :
        this.dtf;

      return (end - start) / 3600000;
    }
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
    this.applyRouteFilters();
  },
  methods: {
    initialize() {
      this.getConfig();
    },
    onEmpresaInput(id) {
      this.idEmpresaSelected = id;
      this.idVeiculosSelected = [];
      if (this.$refs.veiculosSelect && this.$refs.veiculosSelect.setSelectedItems) {
        this.$refs.veiculosSelect.setSelectedItems([]);
      }
    },
    applyRouteFilters() {
      this.$nextTick(() => {
        if (!this.$route.query.idempresa) {
          return;
        }
        const idEmpresa = parseInt(this.$route.query.idempresa);
        this.idEmpresaSelected = idEmpresa;
        if (this.$refs.empresaSelect && this.$refs.empresaSelect.setData) {
          this.$refs.empresaSelect.setData(idEmpresa);
        }
        if (this.$route.query.idveiculo) {
          const idVeiculo = parseInt(this.$route.query.idveiculo);
          this.idVeiculosSelected = [idVeiculo];
          if (this.$refs.veiculosSelect && this.$refs.veiculosSelect.setSelectedItems) {
            this.$refs.veiculosSelect.setSelectedItems([idVeiculo]);
          }
        }
      });
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        silent: true,
        onSuccess: (response) => {
          this.config = response.data[0];
          [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);

          if (this.$route.query.dti) {
            this.dti = new Date(this.$route.query.dti);
          }

          if (this.$route.query.dtf) {
            this.dtf = new Date(this.$route.query.dtf);
          }
        },
        onError: (e) => {
          console.log("Response : " + e.message);
          if (e.message == "Request failed with status code 401") {
            EventBus.$emit('show-error', { error: e });
          }
        },
      });
    },
    populaRelatorio() {
      this.$refs.form.validate();
      let validDates = this.validateDates();

      if (this.formValidado && validDates) {
        this.loading = true;
        this.posicoes = [];
        this.dtiMapa = DateUtils.getDateSQLFormatted(this.dti);
        this.dtfMapa = DateUtils.getDateSQLFormatted(this.dtf);
        this.key = this.key === 0 ? 1 : 0;
        this.showMapa = true;
      }
    },
    close() {
      this.showMapa = false;
    },
    setDefaultFilters() {
      DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
      this.idVeiculosSelected = [];
      this.idEmpresaSelected = null;
      this.unidadesSelecionadas = [];
      if (this.$refs.empresaSelect && this.$refs.empresaSelect.resetData) {
        this.$refs.empresaSelect.resetData();
      }
      if (this.$refs.veiculosSelect && this.$refs.veiculosSelect.resetData) {
        this.$refs.veiculosSelect.resetData();
      }
      if (this.$refs.unidadesSelect && this.$refs.unidadesSelect.resetData) {
        this.$refs.unidadesSelect.resetData();
      }
    },
    validateDates() {
      this.alertForm = false;
      if (this.idVeiculosSelected.length === 1 && this.dateDiff > 24) {
        this.alertForm = true;
        EventBus.$emit('show-alert', {
          mensagem: this.$t('relPlot.messages.selectTimeDiff24h'),
          tipo: 'error'
        });
      }

      if (this.idVeiculosSelected.length === 2 && this.dateDiff > 12) {
        this.alertForm = true;
        EventBus.$emit('show-alert', {
          mensagem: this.$t('relPlot.messages.selectTimeDiff12h'),
          tipo: 'error'
        });
      }

      if (this.idVeiculosSelected.length === 3 && this.dateDiff > 6) {
        this.alertForm = true;
        EventBus.$emit('show-alert', {
          mensagem: this.$t('relPlot.messages.selectTimeDiff6h'),
          tipo: 'error'
        });
      }

      return !this.alertForm;
    }
  },
}
</script>
